// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2265":"css/app.6929","4372":"css/admin-app.6929"}[chunkId] + ".css";
};